import prepareQueryParamsMixin from '../../mixins/prepareQueryParamsMixin'
import prepareFetchParamsMixin from '../../mixins/prepareFetchParamsMixin'
import DashboardHeader from '../../components/dasboardHeader/index.vue'
import SideNav from '../../components/sideNavBar/index.vue'
import ShareModal from '../../components/ShareModal/index.vue'
import cancelJobModal from '../../components/cancelJobModal/index.vue'
import reviewJobModal from '../../components/reviewJobModal/index.vue'
import JobService from '../../services/jobService'
import { showSuccessToast, showErrorToast } from '../../services/UI'

export default {
  mixins: [prepareQueryParamsMixin, prepareFetchParamsMixin],
  data () {
    return {
      modalActive: false,
      cancelJobModalActive: false,
      reviewJobModalActive: false,
      jobs: [],
      constJobs: [],
      selected: '',
      selected2: '',
      hospitals: [],
      professions: [],
      loading: false,
      jobId: '',
      showMessage: false,
      showMessage2: false,
      showMessage3: false,
      search1: '',
      search2: '',
      search3: '',
      sort: false,
      jobApplicantsRatio: '',
      applicants: '',
      jobsFilled: ''
    }
  },
  components: {
    DashboardHeader,
    SideNav,
    ShareModal,
    cancelJobModal,
    reviewJobModal
  },
  async created () {
    this.loading = true
    this.jobs = await JobService.listMiniJobs()
    this.constJobs = this.jobs
    this.hospitals = await JobService.listBranches()
    this.professions = await JobService.listProfessions()
    this.loading = false
  },
  methods: {
    toggleDropdown (e) {
      this.state = !this.state
    },
    closeMenu (e) {
      if (!this.$el.contains(e.target)) {
        this.state = false
      }
    },
    shareModal () {
      this.modalActive = true
      document.body.classList.add('overlay-bg')
    },
    cancelJobModal (jobId, applicants, jFill) {
      // console.log(jFill)
      this.jobId = jobId
      this.applicants = applicants
      this.jobsFilled = jFill
      this.cancelJobModalActive = true
      document.body.classList.add('open_cancel')
      this.cancelJobId = jobId
    },
    reviewJobModal (id, jobApplicantsRatio) {
      this.jobId = id
      this.reviewJobModalActive = true
      this.jobApplicantsRatio = jobApplicantsRatio
      document.body.classList.add('review-bg')
    },
    close (bool) {
      if (!bool) this.modalActive = !this.modalActive
      else this.modalActive = null
      document.body.classList.remove('overlay-bg')
    },
    async closeJobModal (bool, state) {
      if (!bool) this.cancelJobModalActive = !this.cancelJobModalActive
      else this.cancelJobModalActive = null
      document.body.classList.remove('open_cancel')

      if (state && this.cancelJobId) {
        if (state === 'keep') {
          const res = await JobService.keepMiniJob(this.cancelJobId)
          if (res) {
            showSuccessToast(this, 'Job cancelled Successfully')
          } else {
            showErrorToast(this, 'No Candidate Available')
          }
        } else if (state === 'revoke') {
          const res = await JobService.revokeMiniJobOffers(this.cancelJobId)
          if (res) {
            showSuccessToast(this, 'Job cancelled Successfully')
          } else {
            showErrorToast(this, 'Couldn\'t revoke job')
          }
        }
      }
      this.jobs = await JobService.listMiniJobs()
    },
    async closeReviewJobModal (bool) {
      if (!bool) this.reviewJobModalActive = !this.reviewJobModalActive
      else this.reviewJobModalActive = null
      document.body.classList.remove('review-bg')
      this.loading = true
      this.jobs = await JobService.listMiniJobs()
      this.loading = false
    },
    hideme () {
      const showMe = document.getElementById('showMe')
      if (showMe.style.display === 'none') {
        showMe.style.display = 'block'
      } else {
        showMe.style.display = 'none'
      }
    },
    spaecializationhideme () {
      const showMespacialization = document.getElementById('spaecializationshowMe')
      if (showMespacialization.style.display === 'none') {
        showMespacialization.style.display = 'block'
      } else {
        showMespacialization.style.display = 'none'
      }
    },
    shifthideme () {
      const shiftshowMe = document.getElementById('shiftshowMe')
      if (shiftshowMe.style.display === 'none') {
        shiftshowMe.style.display = 'block'
      } else {
        shiftshowMe.style.display = 'none'
      }
    },
    getDate (data) {
      const date = parseInt(data)
      const res = Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric'
      }).format(new Date(date))
      return res
    },
    passId (id) {
      this.jobId = id
    },
    departmentSearch () {
      this.jobs = this.constJobs
      const filteredJobs = this.jobs.filter(job => {
        return job.department.toLowerCase().includes(this.search1.toLowerCase())
      })
      this.jobs = filteredJobs
      this.search1 = ''
      this.showMessage = false
    },
    specializationSearch () {
      // console.log(this.jobs)
      this.jobs = this.constJobs
      const filteredJobs = this.jobs.filter(job => {
        return job.specialization.toLowerCase().includes(this.search2.toLowerCase())
      })
      this.jobs = filteredJobs
      this.showMessage2 = false
    },
    shiftSearch () {
      this.jobs = this.constJobs
      const filteredJobs = this.jobs.filter(job => {
        return job.shift.toLowerCase().includes(this.search3.toLowerCase())
      })
      this.jobs = filteredJobs
      this.showMessage3 = false
    },
    async reset () {
      // this.search1 = ''
      // this.search2 = ''
      // this.search3 = ''
      // this.showMessage = false
      // this.showMessage2 = false
      // this.showMessage3 = false
      // this.jobs = await JobService.listMiniJobs()
      // this.selected = ''
      // this.selected2 = ''
      await this.$router.push('/upcoming_jobs')
      this.$router.push('/open_jobs')
    },
    async onChange (event) {
      // this.selected2 = ''
      // console.log(event.target.value, this.selected2)
      const hospitalId = event.target.value
      // console.log(event.target.value)
      this.jobs = await JobService.listMiniJobsProfessions(this.selected2, hospitalId)
      // console.log(this.jobs.length)
    },
    async onChange2 (event) {
      // this.selected = ''
      // console.log(event.target.value, this.selected)
      // console.log(event.target.value, this.selected2)
      const professionId = event.target.value
      this.jobs = await JobService.listMiniJobsProfessions(professionId, this.selected)
      // console.log(this.jobs.length)
    },
    convertDate (d) {
      const d1 = new Date(d).toLocaleDateString()
      // console.log(d1)
      var p = d1.split('/')
      return (p[2] + p[1] + p[0])
    },
    sortByDate () {
      const that = this
      var tbody = document.querySelector('.table tbody')
      var rows = [].slice.call(tbody.querySelectorAll('tr'))
      if (!this.sort) {
        rows.sort(function (a, b) {
          return that.convertDate(a.cells[4].innerHTML) - that.convertDate(b.cells[4].innerHTML)
        })
        rows.forEach(function (v) {
          tbody.appendChild(v)
        })
      } else if (this.sort) {
        rows.sort(function (a, b) {
          return that.convertDate(b.cells[4].innerHTML) - that.convertDate(a.cells[4].innerHTML)
        })
        rows.forEach(function (v) {
          tbody.appendChild(v)
        })
      }
      this.sort = !this.sort
    },
    sortByDate2 () {
      const that = this
      var tbody = document.querySelector('.table tbody')
      var rows = [].slice.call(tbody.querySelectorAll('tr'))
      if (!this.sort) {
        rows.sort(function (a, b) {
          return that.convertDate(a.cells[5].innerHTML) - that.convertDate(b.cells[5].innerHTML)
        })
        rows.forEach(function (v) {
          tbody.appendChild(v)
        })
      } else if (this.sort) {
        rows.sort(function (a, b) {
          return that.convertDate(b.cells[5].innerHTML) - that.convertDate(a.cells[5].innerHTML)
        })
        rows.forEach(function (v) {
          tbody.appendChild(v)
        })
      }
      this.sort = !this.sort
    },
    sortId () {
      if (!this.sort) {
        this.jobs = this.constJobs
        const sortedJobs = this.jobs.sort((a, b) => {
          const start = a.code.substring(2)
          const end = b.code.substring(2)
          return start - end
        })
        this.jobs = sortedJobs
      } else if (this.sort) {
        this.jobs = this.constJobs
        const sortedJobs = this.jobs.sort((a, b) => {
          const start = a.code.substring(2)
          const end = b.code.substring(2)
          return end - start
        })
        this.jobs = sortedJobs
      }
      this.sort = !this.sort
    }
  },
  mounted () {
    document.addEventListener('click', this.closeMenu)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.closeMenu)
  }
}
